import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, AlertController, NavParams, LoadingController, IonInput, Platform } from '@ionic/angular';
import * as bcrypt from 'bcryptjs';

@Component({
    selector: 'app-user-pin-verify',
    templateUrl: './user-pin-verify.page.html',
    styleUrls: ['./user-pin-verify.page.scss'],
})
export class UserPINVerifyPage implements OnInit {

    @ViewChild('pin_input', { static: false }) pin_input: IonInput;

    spinner = null;
    user = null;
    pin = '';

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public navParams: NavParams,
        private loadingController: LoadingController
    ) { }

    ngOnInit() {
        this.user = this.navParams.get('user');
    }

    ionViewDidEnter() {
        setTimeout(() => {
            if(this.pin_input) {
                this.pin_input.setFocus();
            }
        }, 100);
    }    

    close() {
        this.modalController.dismiss();
    }

    verify() {
        this.pin = this.pin.trim();
        if(!this.pin.length) {
            return;
        }
        this.presentSpinner("Verifying PIN").then(() => {
            bcrypt.compare(this.pin, this.user.pin_hash, (error, is_match) => {
                if(!error) {
                    if(is_match) {
                        this.spinner.dismiss();
                        this.modalController.dismiss(true);
                    } else {
                        this.spinner.dismiss();
                        this.presentAlert('Invalid PIN', '', 'The PIN you entered is incorrect. Please try again.');
                    }
                }
                else {
                    this.spinner.dismiss();
                    console.log(error);
                }
            });
        })
        .catch(() => {
            this.spinner.dismiss();
        });
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ["OK"],
        });
        await alert.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
